import {
  Component,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  TenderDTO,
  DocumentFileTypeDTO,
  FileDetailsDTO,
  DocumentDTO,
  TenderEnvelopeDTO,
  DocumentEnvelopeDTO,
  SignatureDTO
} from '../../api/plyca-dtos';
import { DossierDTO } from '../../api/plyca-dtos';

import { UserPrefs } from '../../api/UserPrefs-dto';

import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DossierService } from '../dossier.service';

import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import { TranslateService } from '@ngx-translate/core';

import { InterfaceSettings } from '../../api/contract-notice-dto';
import { DocumentService } from '../../documents/document.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PaginationDTO } from '../../api/PaginationModel';
import { catchError, finalize, map, switchMap, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Component({
  selector: 'tenderView',
  templateUrl: 'tenderView.template.html',
  providers: [DialogService]
})
export class tenderViewComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;

  // INFORMACION DEL EXPEDIENTE
  dossier: DossierDTO;
  dossierId: string;
  tender: TenderDTO;
  tenderId: string;
  document: DocumentDTO;
  oe_files: Array<FileDetailsDTO>;
  s1_files: Array<FileDetailsDTO>;
  s2_files: Array<FileDetailsDTO>;
  s3_files: Array<FileDetailsDTO>;

  settings: InterfaceSettings;

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  // userPrefsSubs: Subscription;
  userPrefs: UserPrefs;

  public expandedRows: any;
  public colHeaders: string[];

  public windowHash: string;
  public decipheredEnvelopes: Array<TenderEnvelopeDTO>;
  tagsParent: string[];

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public dossierService: DossierService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private translate: TranslateService,
    public documentService: DocumentService,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private headerActionsService: HeaderActionsService,
    private helpService: HelpService
  ) {
    super();
    this.helpContext();
    if (this.dialogConfig) {
      this.dossier = this.dialogConfig['dossier'];
      this.tenderId = this.dialogConfig['tenderId'];
      this.document = this.dialogConfig['document'];
    }
    this.colHeaders = [this.translate.instant('TenderInfo.document'),
    this.translate.instant('TenderInfo.presentationName')];
    this.subscribe(this.plycaService.getInterfaceSettings('tenderInterfaceSettings.json'),
      x => (this.settings = x));
  }

  helpContext() {
    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.OFERTA_INFO)
        }
      )));
  }

  getDocumentosXSobre(document: DocumentDTO, fileClassification) {
    return this.documentService
      .getTypeDocument(DocumentFileTypeDTO.Original, this.tender.document)
      .filter(doc => fileClassification === doc['fileClassification']);
  }

  ngAfterContentInit(): void {
    this.expandedRows = this.getExpandedRows();
    if (this.document) {
      this.loadTenderByDoc()
    } else {
      this.loadTender(this.tenderId);
    }
    this.windowHash = generateRandomIdentifier();


    this.headerActionsService.addWindowDivider(this.windowHash);

    this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-lg fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.close();
    });
  }

  ngOnDestroy(): void {

    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);

        this.ref = null;
        this.dialogConfig = null;
        super.ngOnDestroy();
      })));
  }

  public isLoaded(): boolean {
    return this.tender !== undefined && this.settings !== undefined;
  }

  getEnvelopeDescription(envelope: TenderEnvelopeDTO) {
    if (envelope.documentEnvelope && envelope.documentEnvelope.length > 0) {
      if (envelope.documentEnvelope[0].envelope) {
        return envelope.documentEnvelope[0].envelope.description;
      }
    }
    return '';
  }

  getEnvelopeDocumentCount(envelope: TenderEnvelopeDTO) {
    if (envelope.documentEnvelope) {
      return envelope.documentEnvelope.filter(
        (doc: DocumentEnvelopeDTO) => doc.file
      ).length;
    }
    return 0;
  }

  close() {
    this.ref.close();
  }

  viewFile(
    document: DocumentEnvelopeDTO
  ) {
    this.subscribe(this.plycaService
      .updateSeeTenderDocument(document.identifier)
      .pipe(
        map(() => {
          this.loadTender(this.tender.identifier);
        })
      ),
      () => {
        this.documentService.viewFile(document.file, [HelpType.VER_DOC_PRESENTADA]);
      });
  }

  downloadEmbedded(document: DocumentEnvelopeDTO) {
    this.subscribe(this.plycaService
      .updateSeeTenderDocument(document.identifier)
      .pipe(
        map(() => {
          this.loadTender(this.tender.identifier);
        })
      ),
      () => {
        this.documentService.downloadEmbedded(document.file);
      });
  }

  loadTenderByDoc() {
    this.subscribe(this.plycaService.getDossierTenderByDocId(this.document),
      (response: PaginationDTO<TenderDTO>) => {
        if (response) {
          let _tender = response.content[0];
          this.loadTender(_tender.identifier);
        }
      });
  }

  loadTender(identifier: string) {
    this.subscribe(this.plycaService.getDossierTender(identifier).pipe(
      tap((response: TenderDTO) => {
        let tender = response;
        if (tender.tenderEnvelopes) {
          // filtramos sobres con documentos y los ordenamos
          this.decipheredEnvelopes = tender.tenderEnvelopes.filter((envelope: TenderEnvelopeDTO) => envelope.documentEnvelope &&
            envelope.documentEnvelope.find((documentEnvelope: DocumentEnvelopeDTO) => documentEnvelope.file) !== undefined)
            .sort((tenderEnvelope1: TenderEnvelopeDTO, tenderEnvelope2: TenderEnvelopeDTO) => tenderEnvelope1.envelope?.order
              - tenderEnvelope2.envelope?.order);
        } else {
          this.decipheredEnvelopes = [];
        }
        console.log('this.decipheredEnvelopes', this.decipheredEnvelopes);
        this.tender = tender;
        this.loaded = true;
      }),
      catchError(error => {
        console.error('Error al consultar oferta con uuid ', identifier, error);
        this.uiService.showMessage(this.translate.instant('General.serverError'));
        this.close();
        return throwError(error);
      })
    )
    );
  }
  /**
  * Devuelve identificadores de tabla para expandir
  */
  private getExpandedRows() {
    let expandedRow: any;
    expandedRow = {};
    if (this.tender && this.tender.tenderEnvelopes) {
      this.tender.tenderEnvelopes.forEach((envelope: TenderEnvelopeDTO) => {
        if (envelope.documentEnvelope) {
          envelope.documentEnvelope.forEach(
            (document: DocumentEnvelopeDTO) =>
              (expandedRow[document.identifier] = 1)
          );
        }
      });
    }
    return expandedRow;
  }

  public signatures(fileDetails: FileDetailsDTO): Array<SignatureDTO> {
    return SignatureDTO.getSignatures(fileDetails);
  }
}
